import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import { getAndSetFeatureFlags } from 'lib/firebase';
import { ErrorBoundary } from '@sentry/react';
import { WebAppErrorShell } from '@quickmd-llc/design-system';
import { isDevToolsEnabled } from 'features/devtools/isDevToolsEnabled';
import { DevToolsShell } from 'features/devtools/DevTools';
import initializeSentry from '@router/initializeSentry';
import Router from '@router/Router';
import { ReactQueryProvider } from 'api/components/ReactQueryProvider';
import { initOrvalTokenModules } from '@api';
import 'react-toastify/dist/ReactToastify.css';
import '@quickmd-llc/design-system/components/toast/Toast.css';
import './index.css';

// we want to call this as early as possible so that whenever orval is used, the module setters exist/have been set, and
// the token getters will actually work
initOrvalTokenModules();

initializeSentry();
getAndSetFeatureFlags();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <WebAppErrorShell
      ErrorBoundary={ErrorBoundary}
      homeHref="/"
      isDevToolsEnabled={isDevToolsEnabled()}
      devTools={<DevToolsShell />}
    >
      <ReactQueryProvider>
        <Router />
        <ToastContainer limit={1} icon={false} />
      </ReactQueryProvider>
    </WebAppErrorShell>
  </StrictMode>,
);
